<template>
  <div class="shopping">
    <div class="collect" @click.stop="collect">
      <img src="../../assets/shop/collect_y.png" v-if="is_collect" />
      <img src="../../assets/shop/collect.png" v-else />
      <span>收藏</span>
    </div>
    <div class="shopCar" @click.stop="toShopCar">
      <img src="../../assets/shop/addCar.png" />
      <span>购物车</span>
    </div>
    <div class="addShopCar" @click="addCar" v-if="detail.type == 1">加入购物车</div>
    <div class="shop" @click="shop" v-if="detail.type == 1">立即购买</div>
    <div class="dingjin" v-if="detail.type == 2" @click="shop">
      <div class="left">
        <span>线上支付定金</span>
        <span>线下提供服务</span>
      </div>
      <div class="right">立即支付定金</div>
    </div>
    <div class="detail" :style="is_show && 'bottom:0'">
      <div class="content">
        <div class="top">
          <img :src="detail.pic[0].pic" class="goodsimg" />
          <div class="right">
            <div class="price">
              <span class="newPrice">￥{{ price || detail.price }}</span>
              <span class="oldPrice" v-if="detail.price_del">￥{{ price_del || detail.price_del }}</span>
            </div>
            <img class="hide" src="../../assets/shop/hide.png" @click="hide" />
            <span class="stock">剩余{{ stock_num || detail.stock_num }}件</span>
            <div class="active_specs">已选：“{{ selskuTitle }}”</div>
          </div>
        </div>
        <div class="inner">
          <span class="specsTxt">规格</span>
          <div class="specs1">
            <div
              class="item"
              :class="products_sku_id == item.id && 'on'"
              v-for="item in detail.sku"
              :key="item.id"
              @click.stop="selSku(item.id)"
            >{{ item.title }}</div>
          </div>
          <div class="shopNum">
            <span>购买数量</span>
            <div class="box">
              <img src="../../assets/shop/reduce.png" @click.stop="changeNum(-1)" alt />
              <input type="text" v-model="num" disabled />
              <img src="../../assets/shop/add.png" @click.stop="changeNum(1)" alt />
            </div>
          </div>
        </div>

        <div class="enter" @click.stop="sure">确定</div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.shopping {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  z-index: 10;
  transition: bottom 0.2s;
  .collect {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100px;

    img {
      width: 45px;
      height: 45px;
    }
    span {
      font-size: 20px;
      color: #666;
    }
  }
  .shopCar {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100px;

    img {
      width: 45px;
      height: 45px;
    }
    span {
      font-size: 20px;
      color: #666;
    }
  }
  .addShopCar {
    flex: 2;
    font-size: 30px;
    color: #fff;
    text-align: center;
    line-height: 100px;
    background: #ef8200;
  }
  .shop {
    flex: 2;
    font-size: 30px;
    color: #fff;
    text-align: center;
    line-height: 100px;
    background: #e42129;
  }
  .dingjin {
    background-color: #e42129;
    display: flex;
    align-items: center;
    color: #fff;
    height: 100px;
    flex: 4;
    .left {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 20px;
      span {
        margin: 5px 0;
      }
    }
    .right {
      flex: 1;
      font-size: 30px;
      text-align: center;
    }
  }
  .detail {
    position: fixed;
    bottom: -3000px;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    padding: 0 24px;
    transition: bottom 0.2s;
    .content {
      height: 770px;
      width: 750px;
      box-sizing: border-box;
      padding: 0 24px;
      background: #fff;
      position: absolute;
      bottom: 0;
      left: 0;
      .top {
        width: 100%;
        height: 210px;
        padding-left: 260px;
        padding-right: 24px;
        box-sizing: border-box;
        position: relative;
        .goodsimg {
          width: 235px;
          height: 235px;
          border: 8px solid #fff;
          position: absolute;
          top: -20px;
          left: -4px;
          background: #fff;
        }

        .right {
          display: flex;
          flex-direction: column;
          position: relative;
          .hide {
            position: absolute;
            top: 10px;
            right: -20px;
            width: 40px;
            height: 40px;
          }
          .price {
            .newPrice {
              font-size: 40px;
              color: #e42129;
            }
            .oldPrice {
              font-size: 24px;
              color: #aeaeae;
              margin-left: 15px;
              text-decoration: line-through;
            }
          }
          .stock {
            font-size: 24px;
            color: #333;
            margin-top: 15px;
          }
          .active_specs {
            margin-top: 15px;
            font-size: 24px;
            color: #333;
          }
        }
      }
      .inner {
        margin-top: 20px;
        width: 100%;
        height: 400px;
        overflow-y: auto;
        .specsTxt {
          font-size: 30px;
          font-weight: 600;
          color: #333;
          margin-top: 30px;
          line-height: 60px;
        }
        .specs1 {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .item {
            height: 60px;
            background-color: #f1f1f1;
            color: #333;
            font-size: 24px;
            line-height: 60px;
            padding: 0 18px;
            border-radius: 10px;
            margin-right: 30px;
            margin-bottom: 15px;
          }
          .on {
            background: #e42129;
            color: #fff;
          }
        }
        .shopNum {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: 130px;
          box-sizing: border-box;
          span {
            font-size: 30px;
            color: #333;
            width: 125px;
            display: inline-block;
          }
          .box {
            display: flex;
            align-items: center;
            input {
              width: 60px;
              height: 40px;
              line-height: 40px;
              font-size: 28px;
              color: #333;
              text-align: center;
              border: none;
            }
            img {
              width: 45px;
              height: 45px;
            }
          }
        }
      }

      .enter {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100px;
        background-color: #e42129;
        color: #fff;
        font-size: 30px;
        line-height: 100px;
        text-align: center;
      }
    }
  }
}
</style>

<script>
export default {
  props: [""],
  data() {
    return {
      is_show: false,
      num: 1,
      stock_num: null,
      price: null,
      price_del: null,
      selskuTitle: "请选择规格",
      products_sku_id: null,
      is_collect: false
    };
  },
  methods: {
    changeNum(a) {
      let num = this.num + a;
      if (num < 1) return;
      this.num = num;
    },
    selSku(id) {
      let [sku] = this.detail.sku.filter(item => item.id == id);
      if (sku.stock_num == 0) return this.$toast("该规格已无库存");
      console.log(sku);

      this.stock_num = sku.stock_num;
      this.price = sku.price;
      this.price_del = sku.price_del;
      this.selskuTitle = sku.title;
      this.products_sku_id = id;
    },
    hide() {
      this.is_show = false;
    },
    setIs_show() {
      this.is_show = true;
    },
    sure() {
      let products_sku_id = this.products_sku_id;
      let num = this.num;
      if (!products_sku_id) return this.$toast("请选择商品规格");

      if (this.shop_type == 1) {
        // 立即购买
        console.log("立即购买");
        let pic = this.detail.pic[0].pic;
        let products_title = this.detail.title;
        let [sku] = this.detail.sku.filter(item => item.id == products_sku_id);
        if (num > sku.stock_num)
          return this.$toast(`该规格最大库存为${sku.stock_num}`);
        let products_sku_title = sku.title;
        let price = sku.price;
        let price_del = sku.price_del;
        let goods_type = this.detail.type;
        console.log(goods_type);
        let arr = [
          {
            products_sku_id,
            num,
            pic,
            products_sku_title,
            price,
            price_del,
            products_title,
            goods_type
          }
        ];

        this.$store.commit("setAccountList", arr);
        this.$store.commit("setSelAddr", {});
        this.$router.push({ name: "orderCommit", query: { is_buy: 1 } });
      } else {
        // 加入购物车

        let [sku] = this.detail.sku.filter(item => item.id == products_sku_id);
        if (num > sku.stock_num)
          return this.$toast(`该规格最大库存为${sku.stock_num}`);

        this.$http({
          url: "addCar",
          data: {
            products_sku_id,
            num
          }
        }).then(res => {
          this.$toast("已加入购物车");
        });
        this.products_sku_id = null;
      }

      this.is_show = false;
    },
    addCar() {
      // 加入购物车
      this.shop_type = 0;
      this.is_show = true;
    },
    shop() {
      this.shop_type = 1;
      this.is_show = true;
    },
    collect() {
      console.log("收藏商品");
      if (this.detail.is_favorite == 1 || this.is_collect) {
        this.$http({
          url: "delCollection",
          data: {
            id: this.detail.favorite_id || this.favorite_id
          }
        }).then(res => {
          this.$toast.success("取消收藏成功");

          this.is_collect = false;
        });

        return;
      }

      let id = this.detail.id;

      this.$http({
        url: "collectionGoods",
        data: {
          id
        }
      }).then(res => {
        this.$toast.success("收藏成功");
        this.favorite_id = res.id;
        this.is_collect = true;
      });
    },
    toShopCar() {
      this.$router.replace({ name: "shopCar" });
    }
  },
  computed: {
    detail() {
      return this.$store.state.goodsDetail;
    }
  },
  watch: {
    detail: {
      deep: true,
      handler(newVal) {
        if (newVal.is_favorite == 1) {
          this.is_collect = true;
        }else{
          this.is_collect = false
        }
      }
    }
  }
};
</script>
